
import { mapState } from 'vuex';

export default {
  name: 'AppProductReviewsInfo',
  props: {
    score: {
      type: Number,
      required: true
    },
    reviewsCount: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      default: 'small',
      validator: v => ['small', 'medium', 'large'].includes(v)
    },
    lineBreak: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    reviewsCountLabel() {
      return this.$t('reviews_count', {
        count: this.reviewsCount.toLocaleString()
      });
    },
    reviewsCountAbbrLabel() {
      return `(${this.reviewsCount})`;
    },
    scoreIconSize() {
      return this.size === 'large' ? 14 : 12;
    },
    scoreText() {
      return this.score.toFixed(1);
    }
  }
};
